

<template>
  <div class="watch-block mt50">
    <div class="container-width">
      <ul class="gg">
        <li class="kd_xx on">
          <a>党建专栏</a>
        </li>
        <li class="kd_xx">
          <a>盛京看点</a>
        </li>
        <li class="kd_xx">
          <a>媒体看盛京</a>
        </li>
      </ul>
      <ul class="kd_lb">
        <li>
          <section class="about-one container-width">
            <div class="container-fluid">
              <div class="row no-gutters">
                <div class="left-nr">
                  <div class="about-one__content-block">
                    <section
                      @click="handleZtjyArticle(item)"
                      v-for="(item, index) in ztjyData"
                      :key="index"
                      v-if="index == 0"
                    >
                      <p class="about-one__tag-line ellipsis">
                        {{ item.title }}
                      </p>
                    </section>
                    <div class="row">
                      <div style="width: 100%">
                        <ul class="about-one__features">
                          <li
                            class="about-one__features-item"
                            v-for="(item, index) in ztjyData"
                            :key="index"
                            @click="handleZtjyArticle(item)"
                            v-if="index > 0"
                          >
                            <span class="iconfont icon-xiangyou"></span>
                            {{ item.title }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <!-- <a href="/sjkd/ztjy" class="thm-btn about-one__btn"
                        >查看更多</a
                      > -->
                  </div>
                </div>
                <div class="right-nr">
                  <div class="about-one__image-wrap wow fadeInRight">
                    <div
                      class="row no-gutters"
                      style="margin-left: 40px; overflow: hidden"
                      @click="handleZtjyArticle(item)"
                      v-for="(item, index) in ztjyData"
                      :key="index"
                      v-if="index == 0"
                    >
                      <img
                        :src="item.img"
                        style="width: 633px; height: 268px; margin-left: auto"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </li>
      </ul>
      <ul class="kd_lb" style="display: none">
        <li>
          <section class="about-one container-width">
            <div class="container-fluid">
              <div class="row no-gutters">
                <div class="left-nr">
                  <div class="about-one__content-block">
                    <section
                      @click="handlesjkdArticle(item)"
                      v-for="(item, index) in sjkdData"
                      :key="index"
                      v-if="index == 0"
                    >
                      <p class="about-one__tag-line ellipsis">
                        {{ item.title }}
                      </p>
                      <!-- <p class="about-one__text">
                          {{ item.description }}
                        </p> -->
                    </section>
                    <div class="row">
                      <div style="width: 100%">
                        <ul class="about-one__features">
                          <li
                            class="about-one__features-item"
                            v-for="(item, index) in sjkdData"
                            :key="index"
                            @click="handlesjkdArticle(item)"
                            v-if="index > 0"
                          >
                            <span class="iconfont icon-xiangyou"></span>
                            {{ item.title }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <a href="/sjkd" class="w-more ml-10">查看更多</a>
                  </div>
                </div>
                <div class="right-nr">
                  <div class="about-one__image-wrap wow fadeInRight">
                    <!-- data-wow-duration="1s" style="visibility: visible; animation-duration: 1s; animation-name: fadeInRight;" -->
                    <div
                      class="row no-gutters"
                      style="margin-left: 40px"
                      @click="handlesjkdArticle(item)"
                      v-for="(item, index) in sjkdData"
                      :key="index"
                      v-if="index == 0"
                    >
                      <img
                        :src="item.img"
                        style="width: 633px; height: 268px; margin-left: auto"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </li>
      </ul>
      <ul class="kd_lb" style="display: none">
        <li>
          <section class="about-one container-width">
            <div class="container-fluid">
              <div class="row no-gutters">
                <div class="left-nr">
                  <div class="about-one__content-block">
                    <section
                      @click="gomtksjArticle(item)"
                      v-for="(item, index) in mtksjData"
                      :key="index"
                      v-if="index == 0"
                    >
                      <p class="about-one__tag-line ellipsis">
                        {{ item.title }}
                      </p>
                      <!-- <p class="about-one__text">
                          {{ item.description }}
                        </p> -->
                    </section>
                    <div class="row">
                      <div style="width: 100%">
                        <ul class="about-one__features">
                          <li
                            class="about-one__features-item"
                            v-for="(item, index) in mtksjData"
                            :key="index"
                            @click="gomtksjArticle(item)"
                            v-if="index > 0"
                          >
                            <span class="iconfont icon-xiangyou"></span>
                            {{ item.title }}
                          </li>
                        </ul>
                      </div>
                    </div>
                    <a href="/sjkd/mtksj" class="w-more ml-10">查看更多</a>
                  </div>
                </div>
                <div class="right-nr">
                  <div class="about-one__image-wrap wow fadeInRight">
                    <!-- data-wow-duration="1s" style="visibility: visible; animation-duration: 1s; animation-name: fadeInRight;" -->
                    <div
                      class="row no-gutters"
                      style="margin-left: 40px"
                      @click="gomtksjArticle(item)"
                      v-for="(item, index) in mtksjData"
                      :key="index"
                      v-if="index == 0"
                    >
                      <img
                        :src="item.img"
                        style="width: 633px; height: 268px; margin-left: auto"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </li>
      </ul>
    </div>
  </div>
</template>
      
<script>
import service from "../../service/index";
import config from "../../config/dev";
export default {
  name: "SEARCHBLOCK",
  props: {},
  data() {
    return {
      sjkdData: [],
      ztjyData: [],
      mtksjData: [],
      DWIDTH: false, // 移动端适配
    };
  },
  methods: {
    // 党建专栏数据
    getSubjectData() {
      let parmes = {
        pageIndex: 1,
        pageSize: 6,
        isshow: "1",
        issuggest: "1",
      };
      service.getSubjectList(parmes, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            item.img =
              config.url +
              "/file/downloadFile/" +
              item.img +
              "?isDownload=true";
          });
        }
        this.ztjyData = res.content || [];
      });
    },
    // 党建专栏 文章
    handleZtjyArticle(e) {
      if (e.url.length) {
        window.open(e.url, "_blank");
      } else {
        let routeUrl = this.$router.resolve({
          path: `/sjkd/ztjy/article`,
          query: {
            id: e.id,
          },
        });
        window.open(routeUrl.href, "_blank");
      }
    },
    // 盛京看点数据
    getWatchData() {
      let parmes = {
        pageIndex: 1,
        pageSize: 6,
        isshow: "1",
        issuggest: "1",
      };
      service.getWatchList(parmes, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            item.img =
              config.url +
              "/file/downloadFile/" +
              item.img +
              "?isDownload=true";
          });
        }
        this.sjkdData = res.content || [];
      });
    },
    // 盛京看点 文章
    handlesjkdArticle(e) {
      if (e.url.length) {
        window.open(e.url, "_blank");
      } else {
        let routeUrl = this.$router.resolve({
          path: `/sjkd/article`,
          query: {
            id: e.id,
          },
        });
        window.open(routeUrl.href, "_blank");
      }
    },
    // 媒体看盛京数据
    getMtksjData() {
      let parmes = {
        pageIndex: 1,
        pageSize: 6,
        isshow: "1",
        issuggest: "1",
      };
      service.getwzMediaViewsjList(parmes, (res) => {
        if (res.content.length) {
          res.content.map((item) => {
            item.img =
              config.url +
              "/file/downloadFile/" +
              item.img +
              "?isDownload=true";
          });
        }
        this.mtksjData = res.content || [];
      });
    },
    // 媒体看盛京 文章
    gomtksjArticle(e) {
      if (e.url.length) {
        window.open(e.url, "_blank");
      } else {
        let articleId = e.id;
        const { href } = this.$router.resolve({
          path: `/lxwm/mtksj/article/${articleId}`,
        });
        window.open(href, "_blank");
      }
    },
  },
  mounted() {
    // 党建专栏数据
    this.getSubjectData();
    // 盛京看点数据
    this.getWatchData();
    // 媒体看盛京数据
    this.getMtksjData();
    if (window.screen.width < 1200) {
      this.DWIDTH = false;
    } else {
      this.DWIDTH = true;
    }
  },
  watch: {},
  destroyed() {},
};
</script>
      
<style scoped lang="scss">
/* 盛京看点 */
.watch-block {
  padding: 0 10px;
  box-sizing: border-box;
  // .container-width {
  //   display: -webkit-flex;
  //   display: flex;
  //   -webkit-box-pack: justify;
  //   -webkit-justify-content: space-between;
  //   -ms-flex-pack: justify;
  //   justify-content: space-between;
  //   border-radius: 5px;
  //   overflow: hidden;
  // }
  .kd_xx:nth-child(1).on a {
    color: #d82a1c;
    border-bottom: 4px solid #d82a1c;
  }
}
.left-nr {
  width: 100%;
}
.right-nr {
  width: 50%;
  display: none;
}
/* 小屏幕（平板，大于等于 420px） */
@media only screen and (max-width: 420px) {
}

/* 小屏幕（平板，大于等于 420px） */
@media only screen and (min-width: 421px) {
}

/* 小屏幕（平板，大于等于 768px） */
@media only screen and (min-width: 768px) {
  .left-nr {
    width: 50%;
  }
  .right-nr {
    display: block;
  }
}

/* 中等屏幕（桌面显示器，大于等于 992px） */
@media only screen and (min-width: 992px) {
}

/* 大屏幕（大桌面显示器，大于等于 1200px） */
@media only screen and (min-width: 1200px) {
}

/* 小屏幕（大桌面显示器 大于等于 1330px） */
@media only screen and (min-width: 1330px) {
}

/* 小屏幕（大桌面显示器 大于等于 1900px） */
@media only screen and (min-width: 1900px) {
}
</style>
      
    
       